// @ts-nocheck
import React, { Fragment } from "react";
import AppRouter from "./routers/AppRouters";
import { Notification } from "./components/notification/Notification";
import Loader from "./components/modal/loader/loadercomponent";
import PubSub from "pubsub-js";
import { eventNames } from "./constants/eventNames";
// AutoLogout is now managed by InactivityProvider
// import AutoLogout from "./services/autologout.service";
import packageJson from "../package.json";
import { AuthService } from "./services/auth.service";

class App extends React.Component {

  constructor(props) {
    super(props);
    this.globalEventsSubscribed = false;
  }

  componentDidMount() {
    if (!this.globalEventsSubscribed) {
      this.subscribeOnGlobalEvents();

      // Note: AutoLogout is now managed by InactivityProvider in index.tsx
      // No need to initialize here to avoid conflicts

      this.globalEventsSubscribed = true;
    }

    let versionElement = document.getElementsByName("version");
    if (versionElement && versionElement[0]) {
      versionElement[0].setAttribute("version", packageJson.version);
    }

    // Clean up orphaned modal-wrappers that might block UI
    // This runs once on app load to clear any stale modals from previous sessions
    this.cleanupOrphanedModals();
  }

  /**
   * Clean up orphaned modal-wrapper elements from the modal-root
   * These can be left behind if components don't properly unmount
   */
  cleanupOrphanedModals = () => {
    const modalRoot = document.getElementById("modal-root");
    if (modalRoot) {
      // Clear all children from modal-root on initial load
      // This ensures no stale modals block the UI
      while (modalRoot.firstChild) {
        modalRoot.removeChild(modalRoot.firstChild);
      }
    }
  };

  componentWillUnmount() {
    // cleanup listeners to avoid duplicates
    window.removeEventListener("storage", this._storageListener);
    window.removeEventListener("keyup", this.handleGlobalKeyUp);
    window.removeEventListener("click", this.handleGlobalClick);
  }

  subscribeOnGlobalEvents() {
    this._storageListener = (event) => {
      if (event.key === "FORCE_LOGOUT") {
        AuthService.logout();
        window.location.href = "/login";
      }
    };

    window.addEventListener("storage", this._storageListener);
    window.addEventListener("keyup", this.handleGlobalKeyUp);
    window.addEventListener("click", this.handleGlobalClick);
  }

  handleGlobalClick = (event) => {
    PubSub.publish(eventNames.globalClick, event);
  };

  handleGlobalKeyUp = (event) => {
    PubSub.publish(eventNames.globalKeyUp, event);
  };

  render() {
    return (
        <Fragment>
          <AppRouter />
          <Notification />
          <Loader />
        </Fragment>
    );
  }
}

export default App;
